import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { VoucherFacade } from './+state';
import { VoucherStateModule } from './+state/voucher.state.module';

import {
  VoucherService
} from './services';

@NgModule({
  imports: [CommonModule, VoucherStateModule],
})
export class DomainVoucherModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainVoucherModule,
      providers: [
        VoucherService,
        VoucherFacade
      ],
    };
  }
}
